import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";


function Registration() {
  const { t } = useTranslation();
  const location = useLocation();


    const handleClick1 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform');
  };
     const handleClick2 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform');
  };
     const handleClick3 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform');
  };
      const handleClick4 = () => {      
  window.open('https://docs.google.com/forms/d/e/1FAIpQLSc1wy9qQ3Hdiz7HipbozUxvNZwFAhSG4vsCtVtPmP_l8WIH9g/viewform', '_blank');
};
      const handleClick5 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSd20D8uhIulksZgq5NcD0Q1Jte71dKmUCCQFtHZ4fdI5PuAeQ/viewform');
  };
      const handleClick6 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSd20D8uhIulksZgq5NcD0Q1Jte71dKmUCCQFtHZ4fdI5PuAeQ/viewform');
  };

      const handleClick7 = () => {
   window.open('https://docs.google.com/forms/d/e/1FAIpQLSfw79a85sHFn3zXedEE8bfWOwSPc82VZ28drPHTPhJm2eJG9w/viewform');
  };
      const handleClick8 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform');
  };



  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const asArray = (key) => {
    const raw = t(key, { returnObjects: true });
    return Array.isArray(raw) ? raw : [];
  };

  return (
    <div className="w-full min-h-screen text-gray-900 font-sans" style={{ paddingTop: "6rem" }}>
      {/* Header */}
      <header
        className="text-center py-8 border-b-4 border-yellow-400"
        style={{ backgroundColor: "#047180" }}
      >
        <h1 className="text-4xl font-extrabold tracking-wide text-white">
          {t("registration.header.title")}
        </h1>
      </header>

      {/* SmartLAB Section */}
      <section 
      id="afterschool-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-blue-600 mb-4">{t("registration.sections.afterschool.title")}</h2>
            <p className="text-lg font-semibold text-gray-700 mb-2">
              {t("registration.sections.afterschool.subtitle")}
            </p>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              {t("registration.sections.afterschool.taglineLine1")} <br /> {t("registration.sections.afterschool.taglineLine2")}
            </p>
            <button onClick={handleClick1} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              {t("registration.buttons.registerHere")}
            </button>
            <p className="mt-4 text-sm">
              info@choicestfruit.com
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-2">{t("registration.labels.learn")}</h3>
            <ul className="custom-list pl-0 space-y-2">
              {asArray("registration.sections.afterschool.learn").map((item, index) => (
                <li key={`${index}-${item}`}>{item}</li>
              ))}
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">{t("registration.labels.whatItIs")}</h3>
              <p>{t("registration.sections.afterschool.whatItIs")}</p>
              <p className="mt-2 font-semibold text-gray-800">
                {t("registration.sections.afterschool.openTo")}
              </p>
              <p className="mt-1 text-sm text-gray-600">
                {t("registration.sections.afterschool.serving")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Senior Tech Club Section */}
      <section 
      id="seniors-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-green-600 mb-4">{t("registration.sections.seniors.title")}</h2>
            <p className="text-lg font-semibold text-gray-700 mb-2">
              {t("registration.sections.seniors.subtitle")}
            </p>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              {t("registration.sections.seniors.taglineLine1")} <br /> {t("registration.sections.seniors.taglineLine2")} <br /> {t("registration.sections.seniors.taglineLine3")}
            </p>
            <button onClick={handleClick2} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              {t("registration.buttons.registerHere")}
            </button>
            <p className="mt-4 text-sm">
               info@choicestfruit.com
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-2">{t("registration.labels.learn")}</h3>
            <ul className="custom-list pl-0 space-y-2">
              {asArray("registration.sections.seniors.learn").map((item, index) => (
                <li key={`${index}-${item}`}>{item}</li>
              ))}
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">{t("registration.labels.whatItIs")}</h3>
              <p>{t("registration.sections.seniors.whatItIs")}</p>
              <p className="mt-2 font-semibold text-gray-800">
                {t("registration.sections.seniors.perfectFor")}
              </p>
              <p className="mt-1 text-sm text-gray-600">
                {t("registration.sections.seniors.serving")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Code and Soil Section */}
      <section 
      id="codesoil-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-lime-700 mb-4">{t("registration.sections.codeAndSoil.title")}</h2>
              <p className="text-lg font-semibold text-gray-700 mb-2">
              {t("registration.sections.codeAndSoil.subtitle")}
            </p>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              {t("registration.sections.codeAndSoil.tagline")}
            </p>
            <button onClick={handleClick3} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              {t("registration.buttons.registerHere")}
            </button>
             <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  {asArray("registration.perks.standard").map((item, index) => (
                    <li key={`${index}-${item}`}>{item}</li>
                  ))}
                </ul>
              </div>
            <p className="mt-4 text-sm">
               info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">{t("registration.labels.learn")}</h3>
            <ul className="custom-list pl-0 space-y-2">
              {asArray("registration.sections.codeAndSoil.learn").map((item, index) => (
                <li key={`${index}-${item}`}>{item}</li>
              ))}
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">{t("registration.labels.whatItIs")}</h3>
              <p>{t("registration.sections.codeAndSoil.whatItIs")}</p>
              <p className="mt-2 font-semibold text-gray-800">
                {t("registration.sections.codeAndSoil.ages")}
              </p>
              <p className="mt-1 text-sm text-gray-600">
                {t("registration.sections.codeAndSoil.openTo")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Ambassador Program Section */}
      <section
        id="ambassador-section"
        className="py-12 px-4 md:px-6 flex justify-center"
      >
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-purple-700 mb-4">{t("registration.sections.ambassador.title")}</h2>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              {t("registration.sections.ambassador.tagline")}
            </p>
            <button onClick={handleClick4} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              {t("registration.buttons.applyHere")}
            </button>
             <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  {asArray("registration.perks.standard").map((item, index) => (
                    <li key={`${index}-${item}`}>{item}</li>
                  ))}
                </ul>
              </div>
            <p className="mt-4 text-sm">
              info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">{t("registration.labels.learnDo")}</h3>
            <ul className="custom-list pl-0 space-y-2">
              {asArray("registration.sections.ambassador.learn").map((item, index) => (
                <li key={`${index}-${item}`}>{item}</li>
              ))}
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">{t("registration.labels.whatItIs")}</h3>
              <p>{t("registration.sections.ambassador.whatItIs")}</p>
              <p className="mt-2 font-semibold text-gray-800">
                {t("registration.sections.ambassador.youthAges")}
              </p>
              <p className="mt-1 text-sm text-gray-600">
                {t("registration.sections.ambassador.openTo")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Internship Program Section */}
      <section 
       id="internship-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-cyan-700 mb-4">{t("registration.sections.internship.title")}</h2>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              {t("registration.sections.internship.tagline")}
            </p>
            <button onClick={handleClick5} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              {t("registration.buttons.applyHere")}
            </button>
             <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  {asArray("registration.perks.standard").map((item, index) => (
                    <li key={`${index}-${item}`}>{item}</li>
                  ))}
                </ul>
              </div>
            <p className="mt-4 text-sm">
             info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">{t("registration.labels.learnDo")}</h3>
            <ul className="custom-list pl-0 space-y-2">
              {asArray("registration.sections.internship.learn").map((item, index) => (
                <li key={`${index}-${item}`}>{item}</li>
              ))}
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">{t("registration.labels.whatItIs")}</h3>
              <p>{t("registration.sections.internship.whatItIs")}</p>
              <p className="mt-2 font-semibold text-gray-800">
                {t("registration.sections.internship.youthAges")}
              </p>
              <p className="mt-1 text-sm text-gray-600">
                {t("registration.sections.internship.openTo")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Tech-Pal Program Section */}
      <section 
      id="techpal-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-sky-700 mb-4">{t("registration.sections.techPal.title")}</h2>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              {t("registration.sections.techPal.tagline")}
            </p>
            <button onClick={handleClick6} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              {t("registration.buttons.applyHere")}
            </button>
             <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  {asArray("registration.perks.standard").map((item, index) => (
                    <li key={`${index}-${item}`}>{item}</li>
                  ))}
                </ul>
              </div>
            <p className="mt-4 text-sm">
               info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">{t("registration.labels.learnCollaborate")}</h3>
            <ul className="custom-list pl-0 space-y-2">
              {asArray("registration.sections.techPal.learn").map((item, index) => (
                <li key={`${index}-${item}`}>{item}</li>
              ))}
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">{t("registration.labels.whatItIs")}</h3>
              <p>{t("registration.sections.techPal.whatItIs")}</p>
             
              <p className="mt-2 font-semibold text-gray-800">
                {t("registration.sections.techPal.youthAges")}
              </p>
              <p className="mt-1 text-sm text-gray-600">
                {t("registration.sections.techPal.openTo")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Educator Workshops Section */}
      <section 
      id="workshops-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-orange-700 mb-4">{t("registration.sections.workshops.title")}</h2>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              {t("registration.sections.workshops.tagline")}
            </p>
            <button onClick={handleClick7} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              {t("registration.buttons.registerHere")}
            </button>
            <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  {asArray("registration.perks.workshops").map((item, index) => (
                    <li key={`${index}-${item}`}>{item}</li>
                  ))}
                </ul>
              </div>
            <p className="mt-4 text-sm">
               info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">{t("registration.labels.learnExplore")}</h3>
            <ul className="custom-list pl-0 space-y-2">
              {asArray("registration.sections.workshops.learn").map((item, index) => (
                <li key={`${index}-${item}`}>{item}</li>
              ))}
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">{t("registration.labels.whatItIs")}</h3>
              <p>{t("registration.sections.workshops.whatItIs")}</p>
              <p className="mt-1 text-sm text-gray-600">
                {t("registration.sections.workshops.openTo")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Tech Camps Section */}
      <section 
      id="techcamps-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-teal-700 mb-4">{t("registration.sections.techCamps.title")}</h2>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              {t("registration.sections.techCamps.tagline")}
            </p>
            <button onClick={handleClick8} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              {t("registration.buttons.registerHere")}
            </button>
            <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  {asArray("registration.perks.techCamps").map((item, index) => (
                    <li key={`${index}-${item}`}>{item}</li>
                  ))}
                </ul>
              </div>
            <p className="mt-4 text-sm">
              info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">{t("registration.labels.learnExplore")}</h3>
            <ul className="custom-list pl-0 space-y-2">
              {asArray("registration.sections.techCamps.learn").map((item, index) => (
                <li key={`${index}-${item}`}>{item}</li>
              ))}
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">{t("registration.labels.whatItIs")}</h3>
              <p>{t("registration.sections.techCamps.whatItIs")}</p>
              <p className="mt-1 text-sm text-gray-600">
                {t("registration.sections.techCamps.openTo")}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Registration;
